<div class="footer-wrapper">
  <div class="container footer-container">
    <footer class="footer">
      <div class="column">
        <h2>FASTPARTS</h2>
        <a [routerLink]="['/about-us']">About us</a>
        <a [routerLink]="['/career']">Career</a>
        <h2 class="gapped">CONTACTS</h2>
        <a [routerLink]="['/locations']">Locations</a>
        <a href="https://app.fastparts.is/b2b/auth/login" target="_blank">B2B</a>
        <a href="https://www.facebook.com/fastparts.is" target="_blank">Facebook</a>
        <a [routerLink]="['/contacts']">Send message</a>
      </div>
      <div class="column">
        <h2>INFORMATION</h2>
        <a [routerLink]="['/payments']">Payments</a>
        <a [routerLink]="['/returns']">Returns</a>
        <a [routerLink]="['/delivery']">Delivery</a>
        <a [routerLink]="['/guarantees']">Guarantees</a>
        <a [routerLink]="['/disputes']">Disputes</a>
        <a [routerLink]="['/buying-rules']">Buying rules</a>
        <a [routerLink]="['/privacy-policy']">Privacy policy</a>
        <a [routerLink]="['/terms-and-conditions']">Terms &
          Conditions</a>
      </div>
      <div class="column last-row-mobile">
        <h2>PRODUCTS</h2>
        @for(collection of collections; track collection.id){
        <a [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', collection.slug]"
          [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">{{collection.name}}</a>
        }

        <h2 class="gapped">HELP</h2>
        <!--
                <a href="#">Track my order</a>
                -->
        <a [routerLink]="['/user/account']">My account</a>
        <a [routerLink]="['/faq']">FAQ</a>
        <a [routerLink]="['/contacts']">Send message</a>
      </div>
      <div class="column last-row-mobile">
        <h2>MY ACCOUNT</h2>
        @if(activeCustomer$ | async; as activeCustomer){
        <a [routerLink]="['/user/account']">Account information</a>
        <a [routerLink]="['/user/orders']">Orders</a>
        <a [routerLink]="['/returns']">Returns</a>
        <a [routerLink]="['/user/addresses']">Addresses</a>
        } @else {
        <a class="cursor-enabled" (click)="openLoginDialog()">Login to
          my account</a>
        }
      </div>
    </footer>
    <div class="copyrights">
      <div class="left">
        <p class="copyrights-text">© 2025 FASTPARTS ehf. - Auto parts online
          in Iceland <br /> </p>
        <img src="./../../../../assets/images/logos/TecDoc-inside.svg" alt="tecdoc_logo">
      </div>
      <p class="verified-payments">
        <span class="verified-text">Verified payment methods:</span>
        <span class="images">
          <img src="./../../../../assets/images/footer/mastercard.svg" alt="payment-method">
          <img src="./../../../../assets/images/footer/visa.svg" alt="payment-method">
          <!--
                    <img src="./../../../../assets/images/footer/pei.svg" alt="payment-method">
          -->
        </span>
      </p>
    </div>
    <div class="rules-description">
      <p>The data shown on www.shop.fastpart.is, specifically the entire database, must not be copied. It is not
        permitted to copy or distribute the data or the entire database without the prior written consent of TecDoc
        and/or allow these actions to be carried out by third parties. A contravention constitutes copyright
        infringement and will be prosecuted.</p>
    </div>
    <p class="version">@if(!isProduction){
      Version {{version}}-{{build}}
      } @else {
      Version {{version}}
      }</p>
  </div>
</div>
